export default __webpack_public_path__ + "static/2-c13cac5cdc30f3a8b8e1b832fe5eadee.jpeg";